import { MOBILE_MAX } from './aspect.js';
import { str } from './settingValue.js';
/** The two inspector headings. Their translations already exist in the seven builder dictionaries. */
export const DESKTOP_GROUP = 'Desktop';
export const MOBILE_GROUP = 'Mobile';
/** The phone breakpoint, as a media/container query condition — one spelling for every section. */
export const MOBILE_QUERY = `(max-width:${MOBILE_MAX}px)`;
/**
 * A mobile numeric override → the number to paint on a phone. Absent / unreadable → the desktop value,
 * which is what "same as desktop" means; `fallback` covers the case where the mobile value is absent AND
 * the section computes something else for phones (the video section's legacy 75 % padding).
 */
export function mobileNum(value, desktop, fallback = desktop) {
    return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}
/**
 * A mobile SELECT override → the value to paint on a phone. `inherit` (the default) and an empty/absent
 * value both mean the desktop's.
 */
export function mobileStr(value, desktop) {
    const raw = str(value, 'inherit');
    return raw === 'inherit' || raw === '' ? desktop : raw;
}
/** Is this mobile SELECT actually overriding anything? (`inherit`/absent → no). */
export function overrides(value) {
    const raw = str(value, 'inherit');
    return raw !== 'inherit' && raw !== '';
}
/**
 * One declaration block, per device.
 *
 * Returns the desktop rule, plus the mobile rule in BOTH phone queries when it says something different.
 * An identical mobile block emits nothing — a live storefront pays no extra bytes for a setting nobody
 * has overridden.
 */
export function perDeviceCss(selector, desktopDecl, mobileDecl) {
    const base = desktopDecl ? `${selector}{${desktopDecl}}` : '';
    if (!mobileDecl || mobileDecl === desktopDecl)
        return base;
    return (base +
        `@media${MOBILE_QUERY}{${selector}{${mobileDecl}}}` +
        `@container aqx-page ${MOBILE_QUERY}{${selector}{${mobileDecl}}}`);
}
//# sourceMappingURL=device.js.map